import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { commonBaseUrl } from "network";

export const testimonialSlice = createApi({
    reducerPath: "testimonialSlice",
    baseQuery: fetchBaseQuery({
        baseUrl: commonBaseUrl,
        credentials: "include",
        prepareHeaders: (headers, { getState }) => {
            const state = getState();
            const token = state.auth?.token;
            if (token) {
                console.log('token', token);
                headers.set("authorization", `Bearer ${token}`);
            } else {
                console.warn("Token not found in state.auth");
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        // ✅ Get All Categories
        getTestimonials: builder.query({
            query: ({ page = 1, limit = 10, search = "" }) => ({
                url: `/testimonial?page=${page}&limit=${limit}&search=${search}`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),

        // ✅ Add New Category
        addTestimonial: builder.mutation({
            query: (body) => ({
                url: "/testimonial",
                method: "POST",
                body,
            }),
        }),

        // ✅ Update Existing Category
        updateTestimonial: builder.mutation({
            query: ({ id, body }) => ({
                url: `/testimonial/${id}`,
                method: "PUT",
                body,
            }),
        }),

        // ✅ Delete Category
        deleteTestimonial: builder.mutation({
            query: (id) => ({
                url: `/testimonial/${id}`,
                method: "DELETE",
            }),
        }),
    }),
});

export const {
    useGetTestimonialsQuery,
    useAddTestimonialMutation,
    useUpdateTestimonialMutation,
    useDeleteTestimonialMutation
} = testimonialSlice;
